import store from "../store/index";
import axios from "axios";

const BASE_URL = process.env.VUE_APP_BASEURL;

export async function postMethodToken(url, params) {
  const options = {
    method: "POST",
    url: BASE_URL + url,
    headers: {
      Authorization: "Bearer " + store.state.userLogged.token
    },
    data: params
  };

  try {
    const response = await axios.request(options);
    return response;
  } catch (error) {
    if (error.response.status == 401 && location.pathname != "/login") {
      store.commit("setUser", null);
      window.location.href = "/login";
    } else {
      console.log(error.response);
    }
  }
}

export async function postMethodTokenDoc(url, id, image) {
  var bodyForm = new FormData();
  bodyForm.append("appraisal_id", id);
  bodyForm.append("doc", image);
  const options = {
    method: "POST",
    url: BASE_URL + url,
    headers: {
      Authorization: "Bearer " + store.state.userLogged.token,
      "Content-Type": "multipart/form-data"
    },
    data: bodyForm
  };

  try {
    const response = await axios.request(options);
    return response;
  } catch (error) {
    if (error.response.status == 401 && location.pathname != "/login") {
      store.commit("setUser", null);
      window.location.href = "/login";
    } else {
      console.log(error.response);
    }
  }
}

export async function postMethodTokenImage(url, id, image) {
  var bodyForm = new FormData();
  bodyForm.append("appraisal_id", id);
  bodyForm.append("image", image);
  const options = {
    method: "POST",
    url: BASE_URL + url,
    headers: {
      Authorization: "Bearer " + store.state.userLogged.token,
      "Content-Type": "multipart/form-data"
    },
    data: bodyForm
  };

  try {
    const response = await axios.request(options);
    return response;
  } catch (error) {
    if (error.response.status == 401 && location.pathname != "/login") {
      store.commit("setUser", null);
      window.location.href = "/login";
    } else {
      console.log(error.response);
    }
  }
}

export async function postMethodNoToken(url, params) {
  const options = {
    method: "POST",
    url: BASE_URL + url,
    data: params
  };

  try {
    const response = await axios.request(options);
    return response;
  } catch (error) {
    if (error.response.status == 401 && location.pathname != "/login") {
      store.commit("setUser", null);
      window.location.href = "/login";
    } else {
      console.log(error.response);
    }
  }
}

export async function getMethodToken(url) {
  const options = {
    method: "GET",
    url: BASE_URL + url,
    headers: {
      Authorization: "Bearer " + store.state.userLogged.token
    }
  };

  try {
    const response = await axios.request(options);
    return response;
  } catch (error) {
    if (error.response.status == 401 && location.pathname != "/login") {
      store.commit("setUser", null);
      window.location.href = "/login";
    } else {
      console.log(error.response);
    }
  }
}

export async function getMethodNoToken(url) {
  const options = {
    method: "GET",
    url: BASE_URL + url
  };

  try {
    const response = await axios.request(options);
    return response;
  } catch (error) {
    if (error.response.status == 401 && location.pathname != "/login") {
      store.commit("setUser", null);
      window.location.href = "/login";
    } else {
      console.log(error.response);
    }
  }
}
